import { fetchComRetry } from './httpRetry';

const API_BASE = process.env.REACT_APP_AUTH_API_BASE || 'https://api.leveragesec.com.br';

export class IndicadoresApiError extends Error {
  constructor(message, { status } = {}) {
    super(message);
    this.name = 'IndicadoresApiError';
    this.status = status;
  }
}

// POST /v1/indicadores — série histórica de indicadores para as emissões e janela especificadas.
// Body: { emissao_ids: [int], data_fim: YYYYMM, data_inicio?: YYYYMM }
// Resposta: array de { emissao_id, emissao, periodos: [{ periodo, splits: [...] }] }
// Emissões sem dados para o período são omitidas silenciosamente (sem 404).
export async function postIndicadores(emissaoIds, dataFim, dataInicio = null, comoConvidado) {
  let res;
  try {
    const body = { emissao_ids: emissaoIds.map(id => parseInt(id, 10)), data_fim: parseInt(dataFim, 10) };
    if (dataInicio != null) body.data_inicio = parseInt(dataInicio, 10);
    res = await fetchComRetry(`${API_BASE}/v1/indicadores`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(comoConvidado ? { 'X-Visualizar-Como': 'convidado' } : {}),
      },
      body: JSON.stringify(body),
    });
  } catch (e) {
    throw new IndicadoresApiError('Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.', { status: 0 });
  }
  if (!res.ok) throw new IndicadoresApiError('Não foi possível carregar os indicadores.', { status: res.status });
  return res.json();
}

// POST /v1/relatorio — relatório completo por período para as emissões especificadas.
// Body: { emissao_ids: [int], data_fim: YYYYMM, data_inicio?: YYYYMM }
// Resposta: array de { emissao_id, emissao_nome, gerado_em, periodos: [{ periodo, splits: [...] }] }
// (mesmo formato de /v1/indicadores — "periodos" tem 1 item por mês da janela pedida).
// Emissões sem dados para o período são omitidas silenciosamente.
export async function postRelatorio(emissaoIds, dataFim, dataInicio = null) {
  let res;
  try {
    const body = { emissao_ids: emissaoIds.map(id => parseInt(id, 10)), data_fim: parseInt(dataFim, 10) };
    if (dataInicio != null) body.data_inicio = parseInt(dataInicio, 10);
    res = await fetchComRetry(`${API_BASE}/v1/relatorio`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch (e) {
    throw new IndicadoresApiError('Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.', { status: 0 });
  }
  if (!res.ok) throw new IndicadoresApiError('Não foi possível carregar o relatório.', { status: res.status });
  return res.json();
}
